<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
      <!-- <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb> -->
    </div>

    <div class="content-body">
      <app-custom-loader-c></app-custom-loader-c>

      <section class="card custom_card_pdf">
        <div id="invoice-template" class="card-body">
          <!-- Invoice Company Details -->
          <div id="invoice-company-details" class="custoemPrintFont row">
            <div class="custoemPrintFont col-md-12 col-sm-12 text-center">
              <div>
                <!-- <h2 class="stripe-1" >INVOICE</h2> -->
                <a href="http://www.octaitsolution.com/" class="custoemPrintImageWidth"><img
                    class="custoemPrintImageWidth" src="{{ invoiceConfiguration.clientLogoUrl }}"
                    style="width: 19%; float: left" alt="company logo" /></a>

                <div class="media-body">
                  <ul class="ml-2 px-0 list-unstyled">
                    <div style="float: right; display: inline">
                      <h2 style="color: #078473; font-weight: bold">
                        TAX INVOICE
                      </h2>
                      <!-- Bill Display No   -->
                      <p class="pb-3" style="padding-bottom: 0 !important">
                        #{{ model.displayBillNumber }}
                      </p>
                      <ul class="px-0 list-unstyled">
                        <!-- Balance Due   -->
                        <li *ngIf="model.balanceAmount != 0">Balance Due</li>
                        <li class="lead text-bold-800" *ngIf="model.balanceAmount != 0">
                          {{ currency }} {{ model.balanceAmount }}
                        </li>
                      </ul>
                    </div>

                    <li style="font-size: 1.3rem">
                      <!-- Raghuveer Nagar, Anand Corner Apartment,Wadgaon Sheri,
                      Pune, Maharashtra 411014 -->
                      {{ invoiceConfiguration.invoiceAddress }}
                    </li>

                    <li style="padding-right: 10rem">
                      Email:
                      <a style="color: blue; font-size: large">{{ invoiceConfiguration.invoiceEmail }}</a>
                      Mobile: {{ invoiceConfiguration.invoiceContactNo }}
                    </li>

                    <!-- <li style=" padding-right: 7rem;">Email: <a style="color: blue;font-size:large; ">info@octaitsolution.com</a> Mobile: +91 8686480808</li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!--/ Invoice Company Details -->

          <!-- Invoice Customer Details -->
          <div id="invoice-customer-details" class="row">
            <div class="row col-sm-12 col-md-12">
              <div _ngcontent-eni-c121="" class="col-md-6 col-sm-6">
                <p class="text-muted" style="font-size: x-large !important;">
                  Bill To
                </p>
              </div>
              <div class="col-md-6 col-sm-6 text-right text-md-right" style=" text-align: right !important;">
                <ul class="px-0 list-unstyled" style="font-size: large">
                  <li>
                    <span class="text-muted">Bill Date : </span>{{ model.billDate }}
                  </li>
                  <!-- <li *ngIf="model.balanceAmount!=0"><span class="text-muted">Terms :</span> Due on Receipt</li> -->
                  <!-- <li *ngIf="model.balanceAmount!=0"><span class="text-muted">Due Date :</span> {{duedate(model.billDate)}}</li> -->
                </ul>
              </div>
            </div>
            <div class="col-md-12 col-sm-12 " style="font-size: large;">
              <ul class="px-0 list-unstyled">
                <li class="text-muted">{{ model.customerFullName }}</li>
                <div class="row">
                  <div class="col-md-8 col-sm-12">
                    <p class="text-muted">
                      {{ model.customerAddress }}
                      <br />
                      {{ model.customerContact }}
                    </p>
                  </div>
                </div>
                <li class="text-muted" *ngIf="model.customerGSTNO != ''">
                  GST No: {{ model.customerGSTNO }}
                </li>
                <li class="text-muted" *ngIf="model.customerGSTNO == ''">
                  GST No: NA
                </li>
              </ul>
            </div>
          </div>
          <!--/ Invoice Customer Details -->

          <!-- Invoice Items Details -->
          <div id="invoice-items-details" class="custoemPrintFont pt-2">
            <div class="row">
              <div class="customePrint table-responsive col-sm-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th style="width: 28%">Description</th>
                      <th style="text-align: right">HSN</th>
                      <th style="text-align: right">Amount</th>
                      <th style="text-align: right">MRP</th>
                      <th style="text-align: right">GST</th>
                      <th class="text-right">Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let obj of listBillItems; let i = index">
                      <th scope="row">{{ i + 1 }}</th>
                      <td style="width: 28%">
                        <p>
                          {{ obj.productItemDescription }} <br />{{
                          obj.productItemBarCode
                          }}
                          {{ obj.productItemSerialNo }} <br />Warranty :
                          {{
                          obj.productWarrantyInYear != ""
                          ? obj.productWarrantyInYear
                          : 0
                          }}
                          Year &
                          {{
                          obj.productWarrantyInMonth != ""
                          ? obj.productWarrantyInMonth
                          : 0
                          }}
                          Month
                        </p>
                      </td>
                      <td class="hsnBill">{{ obj.productHSN }}</td>
                      <td class="amountBill">
                        {{obj.productItemPriceWithoutGST}}
                      </td>
                      <td *ngIf="obj.productItemMRP == 0" class="mrpBill">
                        NA
                      </td>
                      <td *ngIf="obj.productItemMRP != 0" class="mrpBill">
                        {{ obj.productItemMRP }}
                      </td>
                      <td class="gstBill">{{ obj.gStAmount }} {{ obj.productItemGstAmount }}</td>

                      <td class="text-right">{{ obj.productItemPrice }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-7 col-sm-7 text-center text-md-left">
                <p class="lead">Payments:</p>
                <div class="row">
                  <div class="col-md-10">
                    <div class="customePrint table-responsive">
                      <table class="table table-borderless table-sm">
                        <thead>
                          <tr>
                            <th>Mode</th>
                            <th>Amount</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let obj of listPayment; let i = index">
                            <td>{{ listPayment[i].payMode }}</td>
                            <td>
                              {{ currency }} {{ listPayment[i].paidAmount }}
                            </td>
                            <td>
                              {{
                              listPayment[i].paymentDate | date : DateFormat
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-sm-5">
                <p class="lead"></p>
                <div class="customePrint table-responsive">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td>Total</td>
                        <td class="text-right">
                          <!-- {{ currency }} {{ totalPriceWithoutGST }} -->
                          {{ currency }} {{ model.totalAmount }}
                        </td>
                      </tr>
                      <tr *ngIf="!model.isIgstBill">
                        <td>CGST(9%)</td>
                        <!-- <td class="text-right">{{ currency }} {{ CGST }} </td> -->
                        <td class="text-right">{{ currency }} {{ model.cgst }} </td>
                      </tr>
                      <tr *ngIf="!model.isIgstBill">
                        <td>SGST(9%)</td>
                        <!-- <td class="text-right">{{ currency }} {{ CGST }}</td> -->
                        <td class="text-right">{{ currency }} {{ model.sgst }}</td>
                      </tr>
                      <tr *ngIf="model.isIgstBill">
                        <td>IGST(18%)</td>
                        <td class="text-right">
                          <!-- {{ currency }} {{ totalGSTAmount }} -->
                          {{ currency }} {{ model.totalGSTAmount }}
                        </td>
                      </tr>
                      <tr>
                        <td>Total Pay</td>
                        <td class="text-right">
                          {{ currency }} {{ model.totalAmountIncGST }}
                        </td>
                      </tr>

                      <!-- <tr>
                        <td>TAX (12%)</td>
                        <td class="text-right">$ 1,788.00</td>
                      </tr> -->

                      <tr>
                        <td class="text-bold-800">Paid Amount</td>
                        <td class="text-bold-800 text-right">
                          - {{ currency }} {{ model.totalpaidAmount }}
                        </td>
                      </tr>
                      <tr>
                        <td>Balance Amount</td>
                        <td class="pink text-right" *ngIf="model.balanceAmount != 0">
                          {{ currency }} {{ model.balanceAmount }}
                        </td>
                        <td class="text-right" *ngIf="model.balanceAmount == 0">
                          {{ currency }} {{ model.balanceAmount }}
                        </td>
                      </tr>

                      <!-- <tr class="bg-grey bg-lighten-4">
                        <td class="text-bold-800">Balance Due</td>
                        <td class="text-bold-800 text-right">$ 12,000.00</td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>

                <!-- <div class="text-center">
                  <p>Authorized person</p>
                  <br>  <br>  <br>



                </div> -->
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />

          <hr class="customePrint" />
          <!-- Invoice Footer -->
          <div id="BankDetails">
            <span><b>Remark</b></span>
            <div class="bottom row" style="padding-top: 1%">
              <div class="col-lg-6 col-sm-6">
                <p>
                  {{ model.remark }}
                </p>
              </div>
              <div class="col-lg-6 col-sm-6"></div>
            </div>
          </div>
          <div id="BankDetails">
            <span><b>Bank Details</b></span>
            <div class="bottom row" style="padding-top: 1%">
              <div class="col-lg-6 col-sm-6">
                Account Number: {{ model.accountNumber }}<br />
                IFSC: {{ model.ifscCode }}<br />
                Branch: {{ model.branchName }}<br />
                GST#: {{ model.gstNo }}
              </div>
              <div class="col-lg-6 col-sm-6"></div>
            </div>
          </div>
          <div style="padding-top: 1%; font-size: 1rem">
            <span><b> Declaration</b></span>
            <div class="bottom row" style="padding-top: 1%">
              <div class="col-lg-8 col-sm-8" style="text-wrap-mode: wrap;" [innerHTML] = "model.invoiceDeclaration">
              </div>
               <br />
                <div class="col-lg-8 col-sm-8" [innerHTML] = "model.invoicePaymentTerm"></div>
              
              <div class="col-lg-4 col-sm-4"></div>
            </div>
          </div>
          <div class="bottom row" style="margin-top: 8%">
            <div class="col-lg-8 col-sm-8">
              <h6>
                This is an electronically generated invoice, no sign required.
              </h6>
            </div>
            <div class="col-lg-4 col-sm-4 text-right">
              <h6>Thank You For Your Business!!</h6>
            </div>
          </div>
          <!--/ Invoice Footer -->
        </div>
        <div>
          <button style="float: right; margin: 48px" type="button" class="btn btn-info btn-lg my-1"
            (click)="getPrint('invoice-template')">
            Print
          </button>
        </div>
      </section>
    </div>
  </div>
</div>